module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ec5a678c6318ecbe41949e7e89ae50cf.png";